export const AuthConfig = {
  clientID: 'btbuwEMUoZso96g6NHiMCJQwVLVhjaBG',
  domain: 'agileupstream.auth0.com',
  callbackURL: '', // 'https://localhost:44307'
};
